import React from 'react';
import ContentLoader from 'react-content-loader';

const BookmarkLoader = () => (
  <ContentLoader
    backgroundColor="var(--s-info-light)"
    foregroundColor="#e6e6e6"
    height={156}
    speed={2}
    viewBox="0 0 700 156"
    width={700}>
    <path d="M 0 0 h 156 v 156 H 0 z" />
    <rect height="16" rx="4" ry="4" width="250" x="176" y="24" />
    <rect height="12" rx="4" ry="4" width="500" x="176" y="64" />
    <rect height="12" rx="4" ry="4" width="350" x="176" y="86" />
    <rect height="12" rx="4" ry="4" width="320" x="176" y="120" />
  </ContentLoader>
);

export default BookmarkLoader;
